import { RootActionType } from '../interfaces';

export const ActionTypes: RootActionType = {
    setToken: 'setToken',
    setTokenTimestamp: 'setTokenTimestamp',
    setIsIdentified: 'setIsIdentified',
    setScreeningUnit: 'setScreeningUnit',
    setDataLoading: 'setDataLoading',
    setIsLanguagesLoaded: 'setIsLanguagesLoaded',
    setIsAppLoaded: 'setIsAppLoaded',
    setShowErrInfoModal: 'setShowErrInfoModal',
    setPopUpErrMessage: 'setPopUpErrMessage',
    setMaxVisitedStepNumber: 'setMaxVisitedStepNumber',
    setAppVersion: 'setAppVersion',
    // Participant
    setParticipant: 'setParticipant',
    // Parameters
    setUseLongAppointment: 'setUseLongAppointment',
    setUseTRMGenderChoice: 'setUseTRMGenderChoice',
    setAllowFirstAppointment: 'setAllowFirstAppointment',
    // Appointment
    setAppointment: 'setAppointment',
    setIsFirstAppointment: 'setIsFirstAppointment',
    setIsRdvLong: 'setIsRdvLong',
    setReasonLongAppointment: 'setReasonLongAppointment',
    setTrmSex: 'setTrmSex',
    setInit: 'setInit',
    setCenterWithAvailabilities: 'setCenterWithAvailabilities',
    setCenterSelected: 'setCenterSelected',
    setHasEventSelected: 'setHasEventSelected',
    setIsBtnBackVisible: 'setIsBtnBackVisible',
    setAppID: 'setAppID',
    setIsRdvModified: 'setIsRdvModified',
    setAppMobile: 'setAppMobile',
    setAppEmail: 'setAppEmail',
};
